import { gql, useMutation } from '@apollo/client';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_PROCESS_TASK } from './get-process-task.hook';
import { GET_PROCESS_TASKS_FOR_TABLE } from './get-process-tasks.hook';
import { GET_PROCESS_BY_ID } from '../processes/get-process-by-id.hook';

const UPDATE_PROCESS_TASK = gql`
  mutation updateProcessTask($payload: UpdateProcessTaskInput!) {
    updateProcessTask(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateProcessTask = ({ onSuccess }: IHookCallbacks) => {
  const [updateProcessTask, {loading}] = useMutation(UPDATE_PROCESS_TASK, {
    onCompleted: () => onSuccess && onSuccess(),
    refetchQueries: [GET_PROCESS_TASKS_FOR_TABLE, GET_PROCESS_TASK, GET_PROCESS_BY_ID],
  });

  return { updateProcessTask, loading };
};
